const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/liho/eCheckin/validation.ts';
import textMap from '@cistec/common_web/components/Forms/utils/translations';
import { ValidationFunction } from '@cistec/common_web/components/Forms/utils/validation';

const checkLength = (value: string | undefined, maxLength: number): boolean => {
    return !!value && value.length > maxLength;
};

export const birthdayValidator = (value: any): any => {
    if (!value) {
        return textMap.lihoNotNull.id;
    } else if (checkLength(value, 10)) {
        textMap.lihoTooLong.id;
    }
};

export const countryValidator = (value: any): any => {
    if (!value) return textMap.lihoNotNull.id;
};

export const emailValidator = (value: any) => {
    if (value && !value.match(/^\S+@\S+\.\S+$/)) {
        return textMap.emailInvalid.id;
    } else if (checkLength(value, 80)) {
        return textMap.lihoTooLong.id;
    } else {
        return undefined;
    }
};

export const cityValidator = (value: any) => {
    if (checkLength(value, 30)) {
        return textMap.lihoTooLong.id;
    } else {
        return undefined;
    }
};

export const arbeitgeberValidator = (value: any) => {
    if (checkLength(value, 30)) {
        return textMap.lihoTooLong.id;
    } else {
        return undefined;
    }
};
export const hausarztValidator = (value: any) => {
    if (checkLength(value, 30)) {
        return textMap.lihoTooLong.id;
    } else {
        return undefined;
    }
};

export const socialSecurityNumberValidator = (value: any) => {
    if (checkLength(value, 100)) {
        return textMap.lihoTooLong.id;
    } else if (!value) {
        return textMap.lihoNotNull.id;
    } else {
        return undefined;
    }
};

export const insuranceNumberValidator = (value: any) => {
    if (!value) {
        return textMap.lihoNotNull.id;
    }
    if (!value.startsWith('80')) {
        return textMap.lihoInsuranceNumberStart.id;
    }
    if (isNaN(Number(value))) {
        return textMap.lihoInsuranceNumberIsNotNumerical.id;
    }
    if (value.length !== 20) {
        return textMap.lihoInsuranceNumberLength.id;
    }
    return undefined;
};

export const validateInsuranceNumber = (value: any) => {
    if (!value) {
        return textMap.lihoNotNull;
    }
    if (!value.startsWith('80')) {
        return textMap.lihoInsuranceNumberStart;
    }
    if (isNaN(Number(value))) {
        return textMap.lihoInsuranceNumberIsNotNumerical;
    }
    if (value.length !== 20) {
        return textMap.lihoInsuranceNumberLength;
    }
    return undefined;
};

export const professionValidator = (value: any) => {
    if (checkLength(value, 50)) {
        return textMap.lihoTooLong.id;
    } else {
        return undefined;
    }
};

export const commentValidator = (value: any) => {
    if (value && value.match(/\//)) {
        return textMap.lihoCommentInvalid.id;
    } else if (checkLength(value, 250)) {
        return textMap.lihoTooLong.id;
    } else {
        return undefined;
    }
};

export const validateKommentarField: ValidationFunction = value => {
    if (value && value.match(/\//)) {
        return textMap.lihoCommentInvalid;
    }
    return undefined;
};
